import { INhomLopSinhVienInsertRequest } from "../../model/request/category/INhomLopSinhVienInsertRequest";
import { IIdsRequest } from "../../model/request/IIdsRequest";
import { INhomLopSinhVien } from "../../model/respone/category/INhomLopSinhVien";
import { apiClient } from "../apiClient";
export const nhomLopSinhVienApi = {
  SelectByNhomLops: (request: IIdsRequest) => apiClient.post(`nhom-lop-sinh-vien/select-by-nhomlops`, request),
  Insert: (request: INhomLopSinhVien) => apiClient.post(`nhom-lop-sinh-vien`, request),
  Deletes: (request: IIdsRequest) => apiClient.post(`nhom-lop-sinh-vien/deletes`, request),
  AddSinhViens: (request: INhomLopSinhVienInsertRequest) => apiClient.post(`nhom-lop-sinh-vien/inserts`, request),
  ScanAddByLopPreview: (request: IIdsRequest) => apiClient.post(`nhom-lop-sinh-vien/scan-add-by-lop/preview`, request),
  ScanAddByLop: (request: IIdsRequest) => apiClient.post(`nhom-lop-sinh-vien/scan-add-by-lop`, request),
  ScanRemoveByLopPreview: (request: IIdsRequest) => apiClient.post(`nhom-lop-sinh-vien/scan-remove-by-lop/preview`, request),
  ScanRemoveByLop: (request: IIdsRequest) => apiClient.post(`nhom-lop-sinh-vien/scan-remove-by-lop`, request),
  ReadAndValidateImport: (payload: any) => apiClient.post(`nhom-lop-sinh-vien/import/read-and-validate`, payload),
  Import: (payload: any) => apiClient.post(`nhom-lop-sinh-vien/import`, payload),
};
